import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { useLocale } from "../contexts/LocaleContext";
import { Trash2, Minus, Plus, ArrowRight } from "lucide-react";

export default function Cart() {
  const { items, remove, setQty, subtotal } = useCart();
  const { fmt } = useLocale();
  const nav = useNavigate();
  if (items.length === 0) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-32 text-center">
        <div className="overline mb-3">Your bag</div>
        <h1 className="font-display text-5xl text-dark">Your cart is empty</h1>
        <p className="text-gray-500 mt-4">Discover timepieces worth keeping for generations.</p>
        <Link to="/shop" className="btn-primary mt-8">Browse Collection <ArrowRight size={14}/></Link>
      </div>
    );
  }
  return (
    <div className="max-w-[1300px] mx-auto px-6 md:px-12 py-14">
      <div className="overline mb-3">Your bag</div>
      <h1 className="font-display text-5xl text-dark mb-10">Cart</h1>
      <div className="grid md:grid-cols-[1fr_360px] gap-10">
        <div className="space-y-4">
          {items.map(i => (
            <div key={i.product_id} data-testid={`cart-item-${i.product_id}`} className="card-luxe p-4 flex gap-4">
              <img src={i.image} className="w-24 h-24 object-cover" alt={i.name}/>
              <div className="flex-1">
                <div className="text-[11px] uppercase tracking-luxe text-copper">{i.brand}</div>
                <div className="font-display text-lg text-dark">{i.name}</div>
                <div className="text-sm text-gray-600 mt-1">{fmt(i.price)}</div>
                <div className="flex items-center gap-3 mt-3">
                  <div className="flex items-center border border-black/10">
                    <button onClick={()=>setQty(i.product_id, i.quantity-1)} className="px-2 py-1 text-gray-500 hover:text-dark"><Minus size={12}/></button>
                    <span className="px-3 text-sm">{i.quantity}</span>
                    <button onClick={()=>setQty(i.product_id, i.quantity+1)} className="px-2 py-1 text-gray-500 hover:text-dark"><Plus size={12}/></button>
                  </div>
                  <button data-testid={`remove-${i.product_id}`} onClick={()=>remove(i.product_id)} className="text-gray-400 hover:text-red-500"><Trash2 size={14}/></button>
                </div>
              </div>
              <div className="font-display text-lg text-dark">{fmt(i.price*i.quantity)}</div>
            </div>
          ))}
        </div>
        <aside className="card-luxe p-6 h-fit">
          <div className="overline mb-4">Order Summary</div>
          <div className="flex justify-between text-sm py-2"><span className="text-gray-600">Subtotal</span><span>{fmt(subtotal)}</span></div>
          <div className="flex justify-between text-sm py-2"><span className="text-gray-600">Shipping</span><span className="text-gray-500">Calculated at checkout</span></div>
          <div className="flex justify-between font-display text-xl pt-4 mt-4 border-t border-black/5"><span>Total</span><span className="text-copper">{fmt(subtotal)}</span></div>
          <button data-testid="checkout-btn" onClick={()=>nav("/checkout")} className="btn-primary w-full justify-center mt-6">Proceed to Checkout <ArrowRight size={14}/></button>
          <Link to="/shop" className="block text-center text-xs uppercase tracking-luxe text-gray-500 hover:text-dark mt-4">Continue Shopping</Link>
        </aside>
      </div>
    </div>
  );
}
